import {ElementType, ElementTypeUtils} from "core/helpers/ElementTypeUtils";

const getValueByType = (type: string) => {
  switch (type) {
    case 'association':
    case 'choice':
    case 'number':
    case 'radio':
    case 'select':
    case 'text':
    case 'textarea': {
      return '';
    }
    case 'autocomplete':
    case 'checkbox_multiple':
    case 'dicom_button':
    case 'select_multiple': {
      return [];
    }
    case 'range': {
      return 5;
    }
    case 'checkbox': {
      return false;
    }
    case 'date':
    case 'datetime':
    case 'time':
    default:
      return null;
  }
};

const getValueByElementData = (
  // TODO swagger model for element data
  data: Array<any> | undefined | null,
  type: string
) => {
  if (!data) {
    return getValueByType(type);
  }

  return ElementTypeUtils.isMultiple(type) ? data : (data?.[0] ?? null);
};

const getInitialValues = (
  // TODO swagger model for element
  elements: Array<any>,
  // TODO swagger model for element data
  data: Array<any>,
  multi: boolean = false,
) => {
  const el = elements.flatMap((element) => {
    if (element.type === ElementType.Collection || element.type === ElementType.AdverseEvent) {
      return [element, ...element.children];
    }
    return [element];
  });

  return el.reduce((initialValues, element, index) => {
    if (element.type === ElementType.Divider) {
      return initialValues;
    }

    const elementData = multi ?
      data.findLast(
          (data, i) =>
              (element?.id === data.element?.id && i === data.element?.position) ||
              i === data.element?.position ||
              i === index
      ) :
      data.findLast((data) => data?.element?.id === element.id);

    const type = multi ? elementData?.element?.type : element.type;

    initialValues[multi ? elementData?.element?.id : element.id] = elementData
      ? getValueByElementData(elementData.data, type)
      : getValueByType(type)
    ;
    return initialValues;
  }, {});
};

export default getInitialValues;